module.exports = __webpack_public_path__ + "static/media/projectOrientedLearning.f22d0e8f.jpg";